import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Note = styled.div`
  margin-top: 20px;
  margin-left: 26px;
  width: 378px;
  font-size: 12px;
  font-style: normal;
  border-width: 1px;
  border-color: #d7d7d7;
  border-style: solid;
  padding: 16px;
`;
const Icon = styled(FontAwesomeIcon)`
  color: #a0a0a0;
  width: 48px;
  float: left;
  font-size: 24px;
  margin-top: 4px;
  margin-right: 12px;
`;
const Title = styled.div`
  margin-bottom: 6px;
  font-size: 15px;
  font-weight: bold;
  color: #808080;
`;
const Text = styled.div`
  float: left;
  width: 310px;
  font-size: 12px;
  font-weight: 400;
`;

export default function CheckoutNote({ library, icon, iconColor, title, children }) {
  return (
    <Note>
      <Icon icon={[library ? library : "fas", icon]} style={{color: iconColor ? iconColor : '#a0a0a0'}}/>
      <Text>
        {title && <Title>{title}</Title>}
        {children}
      </Text>
      <div style={{ clear: "both" }}></div>
    </Note>
  );
}
